(function () {
  function initGiftProducts() {
    const sections = document.querySelectorAll('[data-gift-products]');
    if (!sections.length) return;

    sections.forEach((section) => {
      if (section.dataset.giftProductsInitialized === 'true') return;
      section.dataset.giftProductsInitialized = 'true';

      const sectionRoot = section.closest('#giftProducts') || document;
      const viewport = section.querySelector('.gift-products__viewport');
      const track = section.querySelector('[data-gift-products-track]');
      const prevButton = section.querySelector('[data-gift-products-prev]');
      const nextButton = section.querySelector('[data-gift-products-next]');
      const thumbs = Array.from(sectionRoot.querySelectorAll('[data-gift-products-thumb]'));
      const addToCartButtons = Array.from(section.querySelectorAll('[data-gift-add-cart]'));

      if (!viewport || !track) return;

      const originalSlides = Array.from(track.querySelectorAll('[data-gift-products-slide]'));
      if (!originalSlides.length) return;

      originalSlides.forEach((slide, index) => {
        slide.dataset.realIndex = String(index);
      });

      const carousels = originalSlides.map((slide) => createInnerCarousel(slide));

      let currentRealIndex = 0;
      let currentTrackIndex = 0;
      let isAnimating = false;
      let animationFallbackTimer = null;
      let trackSlides = [];

      if (originalSlides.length > 1) {
        const lastClone = originalSlides[originalSlides.length - 1].cloneNode(true);
        const firstClone = originalSlides[0].cloneNode(true);

        lastClone.classList.add('is-clone');
        firstClone.classList.add('is-clone');

        lastClone.dataset.realIndex = String(originalSlides.length - 1);
        firstClone.dataset.realIndex = '0';

        lastClone.dataset.cloneType = 'last';
        firstClone.dataset.cloneType = 'first';

        track.insertBefore(lastClone, originalSlides[0]);
        track.appendChild(firstClone);
      }

      trackSlides = Array.from(track.children);

      currentTrackIndex = originalSlides.length > 1 ? 1 : 0;
      currentRealIndex = 0;

      function clearAnimationLock() {
        isAnimating = false;

        if (animationFallbackTimer) {
          window.clearTimeout(animationFallbackTimer);
          animationFallbackTimer = null;
        }
      }

      function getTrackOffsetByIndex(trackIndex) {
        const targetSlide = trackSlides[trackIndex];
        if (!targetSlide) return 0;

        const viewportWidth = viewport.clientWidth;
        const slideWidth = targetSlide.getBoundingClientRect().width;
        const slideLeft = targetSlide.offsetLeft;

        return slideLeft - ((viewportWidth - slideWidth) / 2);
      }

      function setTrackPosition(trackIndex, useTransition) {
        const offset = getTrackOffsetByIndex(trackIndex);
        track.style.transition = useTransition ? 'transform .4s ease' : 'none';
        track.style.transform = `translateX(-${offset}px)`;
      }

      function updateActiveStates() {
        originalSlides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === currentRealIndex);
        });

        thumbs.forEach((thumb) => {
          const thumbIndex = Number(thumb.dataset.thumbIndex);
          thumb.classList.toggle('is-active', thumbIndex === currentRealIndex);
        });
      }

      function syncCarouselPlayback() {
        carousels.forEach((carousel, index) => {
          if (!carousel) return;

          if (index === currentRealIndex) {
            carousel.start();
          } else {
            carousel.stop();
          }
        });
      }

      function moveToTrackIndex(trackIndex, useTransition = true) {
        currentTrackIndex = trackIndex;

        const activeTrackSlide = trackSlides[currentTrackIndex];
        if (activeTrackSlide) {
          currentRealIndex = Number(activeTrackSlide.dataset.realIndex || 0);
        }

        setTrackPosition(currentTrackIndex, useTransition);
        updateActiveStates();
        syncCarouselPlayback();
      }

      function normalizeLoopPosition() {
        if (originalSlides.length <= 1) {
          clearAnimationLock();
          return;
        }

        const activeTrackSlide = trackSlides[currentTrackIndex];
        if (!activeTrackSlide) {
          clearAnimationLock();
          return;
        }

        const cloneType = activeTrackSlide.dataset.cloneType;

        if (cloneType === 'last') {
          currentTrackIndex = originalSlides.length;
          currentRealIndex = originalSlides.length - 1;
          setTrackPosition(currentTrackIndex, false);
        } else if (cloneType === 'first') {
          currentTrackIndex = 1;
          currentRealIndex = 0;
          setTrackPosition(currentTrackIndex, false);
        }

        updateActiveStates();
        syncCarouselPlayback();
        clearAnimationLock();
      }

      function startAnimationLock() {
        isAnimating = true;

        if (animationFallbackTimer) {
          window.clearTimeout(animationFallbackTimer);
        }

        animationFallbackTimer = window.setTimeout(() => {
          normalizeLoopPosition();
        }, 500);
      }

      function goNext() {
        if (isAnimating || originalSlides.length <= 1) return;
        startAnimationLock();
        moveToTrackIndex(currentTrackIndex + 1, true);
      }

      function goPrev() {
        if (isAnimating || originalSlides.length <= 1) return;
        startAnimationLock();
        moveToTrackIndex(currentTrackIndex - 1, true);
      }

      function goToRealIndex(realIndex) {
        if (isAnimating) return;
        if (realIndex < 0 || realIndex >= originalSlides.length) return;
        if (realIndex === currentRealIndex) return;

        const targetTrackIndex = originalSlides.length > 1 ? realIndex + 1 : realIndex;
        startAnimationLock();
        moveToTrackIndex(targetTrackIndex, true);
      }

      function handleResize() {
        clearAnimationLock();
        setTrackPosition(currentTrackIndex, false);
      }

      prevButton?.addEventListener('click', goPrev);
      nextButton?.addEventListener('click', goNext);

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = Number(thumb.dataset.thumbIndex);
          if (Number.isNaN(index)) return;
          goToRealIndex(index);
        });
      });

      let touchStartX = 0;
      let touchStartY = 0;
      let touchEndX = 0;
      let touchEndY = 0;

      function isSpViewport() {
        return window.matchMedia('(max-width: 767px)').matches;
      }

      viewport.addEventListener('touchstart', (event) => {
        if (!isSpViewport()) return;
        if (!event.touches || !event.touches.length) return;

        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        touchEndX = touchStartX;
        touchEndY = touchStartY;
      }, { passive: true });

      viewport.addEventListener('touchmove', (event) => {
        if (!isSpViewport()) return;
        if (!event.touches || !event.touches.length) return;

        touchEndX = event.touches[0].clientX;
        touchEndY = event.touches[0].clientY;
      }, { passive: true });

      viewport.addEventListener('touchend', () => {
        if (!isSpViewport()) return;
        if (isAnimating || originalSlides.length <= 1) return;

        const diffX = touchEndX - touchStartX;
        const diffY = touchEndY - touchStartY;
        const absX = Math.abs(diffX);
        const absY = Math.abs(diffY);

        if (absX < 30) return;
        if (absX <= absY) return;

        if (diffX < 0) {
          goNext();
        } else {
          goPrev();
        }
      }, { passive: true });

      track.addEventListener('transitionend', (event) => {
        if (event.target !== track || event.propertyName !== 'transform') return;
        normalizeLoopPosition();
      });

      window.addEventListener('resize', handleResize);

      addToCartButtons.forEach((button) => {
        button.addEventListener('click', async () => {
          if (button.disabled) return;

          const variantId = button.dataset.variantId;
          if (!variantId) return;

          button.disabled = true;

          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                id: variantId,
                quantity: 1
              })
            });

            if (!response.ok) {
              throw new Error('Failed to add item to cart.');
            }

            window.location.href = '/cart';
          } catch (error) {
            console.error(error);
            alert('カートへの追加に失敗しました。もう一度お試しください。');
            button.disabled = false;
          }
        });
      });

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          currentTrackIndex = originalSlides.length > 1 ? 1 : 0;
          currentRealIndex = 0;
          clearAnimationLock();
          setTrackPosition(currentTrackIndex, false);
          updateActiveStates();
          syncCarouselPlayback();
        });
      });
    });
  }

  function createInnerCarousel(slide) {
    const carousel = slide.querySelector('[data-gift-product-carousel]');
    if (!carousel) return null;

    const images = Array.from(carousel.querySelectorAll('[data-gift-product-image]'));
    const dots = Array.from(carousel.querySelectorAll('[data-gift-product-dot]'));

    if (!images.length) return null;

    let currentImageIndex = 0;
    let timerId = null;
    const delay = Number(carousel.dataset.autoplayDelay || 4300);

    function render() {
      images.forEach((image, index) => {
        image.classList.toggle('is-active', index === currentImageIndex);
      });

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentImageIndex);
      });
    }

    function goToImage(index) {
      if (index < 0) {
        currentImageIndex = images.length - 1;
      } else if (index >= images.length) {
        currentImageIndex = 0;
      } else {
        currentImageIndex = index;
      }

      render();
    }

    function nextImage() {
      goToImage(currentImageIndex + 1);
    }

    function start() {
      stop();
      if (images.length <= 1) return;
      timerId = window.setInterval(nextImage, delay);
    }

    function stop() {
      if (!timerId) return;
      window.clearInterval(timerId);
      timerId = null;
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.dotIndex);
        if (Number.isNaN(index)) return;
        goToImage(index);
        start();
      });
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);

    render();

    return {
      start,
      stop
    };
  }

  function initGiftMvScrollAnimations() {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const fadeInObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('is-visible');
          }, index * 150);
        }
      });
    }, observerOptions);

    document.querySelectorAll('.gift-mv__fade-in').forEach((element) => {
      fadeInObserver.observe(element);
    });
  }

  function initGiftSceneScrollAnimations() {
    const giftScenes = document.querySelectorAll('#giftScene .gift-scene, #giftSceneSingle .gift-scene-single');
    if (!giftScenes.length) return;

    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const sceneObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    giftScenes.forEach((scene) => sceneObserver.observe(scene));
  }

  function initGiftMvImageSequence() {
    const section = document.getElementById('giftMv');
    if (!section) return;

    const isPc = window.matchMedia('(min-width: 768px)').matches;

    const activeLayout = isPc
      ? section.querySelector('.gift-mv__layout--pc')
      : section.querySelector('.gift-mv__layout--sp');

    if (!activeLayout) return;

    const order = [
      '.gift-mv__image--01',
      '.gift-mv__image--02',
      '.gift-mv__image--04',
      '.gift-mv__image--06',
      '.gift-mv__image--03',
      '.gift-mv__image--05',
      '.gift-mv__image--07'
    ];

    const items = order
      .map((selector) => activeLayout.querySelector(selector))
      .filter(Boolean);

    const subtitles = Array.from(activeLayout.querySelectorAll('.gift-mv__subtitle'));

    const titles = isPc
      ? Array.from(activeLayout.querySelectorAll('.gift-mv__title--01, .gift-mv__title--02'))
      : Array.from(activeLayout.querySelectorAll('.gift-mv__title-line'));

    const imageInterval = 400;
    const subtitleDelayAfterImages = 900;
    const titleDelayAfterSubtitle = 1100;

    items.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add('is-show');
      }, index * imageInterval);
    });

    const imageSequenceEnd = (items.length - 1) * imageInterval;

    setTimeout(() => {
      subtitles.forEach((subtitle) => {
        subtitle.classList.add('is-show');
      });
    }, imageSequenceEnd + subtitleDelayAfterImages);

    setTimeout(() => {
      titles.forEach((title) => {
        title.classList.add('is-show');
      });
    }, imageSequenceEnd + subtitleDelayAfterImages + titleDelayAfterSubtitle);
  }

  function initAll() {
    initGiftProducts();
    initGiftMvScrollAnimations();
    initGiftMvImageSequence();
    initGiftSceneScrollAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();